/**
 * @deprecated use `whenW`
 */

/**
 * @deprecated use `whenW`
 */
export function when(predicate, onSuccess) {
  return function (value) {
    return predicate(value) ? onSuccess(value) : value;
  };
}
export function whenW(predicate, onSuccess) {
  return function (value) {
    return predicate(value) ? onSuccess(value) : value;
  };
}